import React, { useState } from 'react';
import './App.css';
import Menu from './components/Menu';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand, Alert } from 'reactstrap';

function Formularios() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    const openLink = (url) => {
        if(window.ReactNativeWebView){
            window.ReactNativeWebView.postMessage(url);
        }
        else{
            window.open(url);
        }
    };

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Formulários</NavbarBrand>
                </Navbar>
                <Container>
                    <Row>
                        <Col className="mt-3">
                            <button onClick={() => { openLink('https://app.kravmaga.org.br/adm/filiacao') }} className="btn btn-lg btn-primary btn-block text-left">Pedido de Filiação na FIKM</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-2">
                            <button onClick={() => { openLink('https://app.kravmaga.org.br/adm/renovacao') }} className="btn btn-lg btn-primary btn-block text-left">Pedido de Renovação da Filiação na FIKM</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-2">
                            <button onClick={() => { openLink('https://app.kravmaga.org.br/adm/exame') }} className="btn btn-lg btn-primary btn-block text-left">Inscrição para Exame de Faixa</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-2">
                            <button onClick={() => { openLink('https://app.kravmaga.org.br/adm/seminario') }} className="btn btn-lg btn-primary btn-block text-left">Inscrição para Seminário</button>
                        </Col>
                    </Row>                   
                </Container>
            </div>
        </div>
    );
}

export default Formularios;
